import {Component} from 'react';
const {registerBlockType} = wp.blocks;
const {
  InspectorControls
} = wp.editor;
const {
  PanelBody,
} = wp.components;

// import CustomInspectorControls from "../../../gutenberg/js_common/CustomInspectorControls";
import * as helpers from './js_common/_helpers';
import CustomInspectorControls from "./js_common/CustomInspectorControls";
// import BlockShop from "../../../gutenberg/js_dzsap/BlockShop";
import {BlockFactoryContent} from './blockFactoryContent';
import BlockShop from "../../../gutenberg/js_dzsap/BlockShop";
import './blockFactory.scss';

let __ = (arg) => {
  return arg;
};


if (wp.i18n) {
  __ = wp.i18n.__;
}

export class BlockFactory  {
  constructor(props) {
    // super(props);

    this.blockAttributes = {
      blockKey: '',
      blockTitle: '',
      keywords: [
        __('Shop'),
        __('Table'),],
      blockIcon: 'format-audio',
      blockCategory: 'common',
      blockDescription: __('چیدمان فروشگاه ووکامرس قابل تنظیم'),
      configAttributes: {},
    }

    this.blockAttributes = {...this.blockAttributes, ...props};
    // console.log('this.blockAttributes - ',this.blockAttributes);
    this.initBlock()
  }




  initBlock(){

    // console.log('initBlock()', this, this.blockAttributes);

    let Compon = (
      <div>test</div>
    )

    registerBlockType(this.blockAttributes.blockKey, {
      // Block Title
      title: this.blockAttributes.blockTitle,
      // Block Description
      description: this.blockAttributes.blockDescription,
      // Block Category
      category: this.blockAttributes.blockCategory,
      // Block Icon
      icon: this.blockAttributes.blockIcon,
      // Block Keywords
      keywords: this.blockAttributes.keywords,
      attributes: this.blockAttributes.configAttributes,
      // Defining the edit interface
      edit: props => {
        const {
          attributes
        } = props;

        const {configAttributes} = this.blockAttributes;

        let uploadButtonLabel = __('Upload');

        if (props.attributes.dzsap_meta_item_source || props.attributes.source) {
          uploadButtonLabel = __('آپلود دیگری انتخاب کنید');
        }

        function onlyUnique(value, index, self) {
          if(value!==undefined){
            return self.indexOf(value) === index;
          }
        }

        const categories = Object.keys(configAttributes).map(key=> { return configAttributes[key].category ;} ).filter(onlyUnique);


        // console.log({categories});

        return [
          !!props.isSelected && (
            <InspectorControls key="inspector">
              {categories.map((categoryName)=>{
                let controlsForCategory = Object.keys(configAttributes).map((configOptionKey)=> {
                  if(configAttributes[configOptionKey].category===categoryName){
                    return {...configAttributes[configOptionKey], ...{configOptionKey}} ;
                  }
                }).filter(function( element ) {
                  return element !== undefined;
                });

                return categoryName ?  (
                  <PanelBody title={categoryName}>
                    <CustomInspectorControls
                      arr_options={controlsForCategory}
                      uploadButtonLabel={uploadButtonLabel}
                      {...props}
                    />
                  </PanelBody>
                ) : ''
              })}

            </InspectorControls>
          ),
          <div className={props.className}>
            <BlockFactoryContent
              configAttributes={configAttributes}
              uploadButtonLabel={uploadButtonLabel}
              attributes={props.attributes}
              setAttributes={props.setAttributes}
            />
          </div>
        ];
      },

      save() {
        // -- Rendering in PHP
        return null;
      },
    });

  }

}